import React from 'react';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { withRecaptcha } from '@/lib/recaptcha';
import { redirectToUnderConstructionPage } from '@/utils/rewrites';
import ForgotForm from '@/forms/forgot-form';
import { AuthLayout, Layout } from '@/components/templates';
import { NextPageWithLayout } from '@/types';

const PageContent = withRecaptcha(() => {
    return (
        <>
            <ForgotForm />
        </>
    );
});

const ForgotPasswordPage: NextPageWithLayout = () => {
    const { t } = useTranslation(); // Translations

    return (
        <>
            <NextSeo title={t('seo:forgot-password.title')} />

            <PageContent />
        </>
    );
};

ForgotPasswordPage.getLayout = (page: React.ReactElement) => {
    return (
        <Layout>
            <AuthLayout activeSide="right" variant="form">
                {page}
            </AuthLayout>
        </Layout>
    );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
    const rules = redirectToUnderConstructionPage();

    const translations = await serverSideTranslations(context?.locale as string, ['common', 'seo', 'auth']);

    return {
        ...rules,
        props: {
            ...translations,
        },
    };
};

export default ForgotPasswordPage;
